import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SlotCounterStationBarChart from '@/components/Counter/SlotCounterStationBarChart';
import dateUtils from '@/utils/dateUtil';
import { mapGetters } from 'vuex';
export default {
  name: 'StationSale',
  components: {
    SlotCounterStationBarChart: SlotCounterStationBarChart
  },
  data: function data() {
    var _this = this;

    return {
      datePickerValue: dateUtils.todayTimestamp() * 1000,
      slotsMapping: [],
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return pTime.getTime() < (_this.userInfo.queryDataDays > 0 ? new Date() - _this.userInfo.queryDataDays * 86400 * 1000 - 86400 * 1000 : new Date() - 365 * 86400 * 1000) || pTime.getTime() > new Date();
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), mapGetters('user', ['userInfo'])),
  methods: {}
};